import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const createEducationAffiliation = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/organizations/education-connection/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getEducationAffiliations = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/organizations/education-connection/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateEducationAffiliation = ({
  version = 'v1',
  payload,
  affiliationKey,
}) =>
  client
    .request({
      url: `${version}/organizations/education-connection/${affiliationKey}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteEducationAffiliation = ({
  version = 'v1',
  affiliationKey,
}) =>
  client
    .request({
      url: `${version}/organizations/education-connection/${affiliationKey}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createEmploymentConnection = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/organizations/employment-connection/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getEmploymentConnections = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/organizations/employment-connection/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateEmploymentConnection = ({
  version = 'v1',
  payload,
  experienceKey,
}) =>
  client
    .request({
      url: `${version}/organizations/employment-connection/${experienceKey}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteEmploymentConnection = ({ version = 'v1', experienceKey }) =>
  client
    .request({
      url: `${version}/organizations/employment-connection/${experienceKey}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createAffiliation = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/organizations/connection/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getConnectionSet = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/organizations/connection/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getMemberManagementList = ({ params, version = 'v1' }) =>
  client
    .request({
      url: `${version}/organizations/employment-connection/member-management-list/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateMemberManagementDetails = ({
  payload,
  params,
  memberId,
  version = 'v1',
}) =>
  client
    .request({
      url: `${version}/organizations/employment-connection/${memberId}/member-management-update/`,
      method: RequestMethod.PATCH,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getMemberContext = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/organizations/organization/context/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getEmploymentAffiliationReasons = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/organizations/affiliation-reasons/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getIntermediaryOrganizations = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/organizations/intermediary/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getIntermediaryOrganizationDistricts = ({
  params,
  version = 'v1',
}) =>
  client
    .request({
      url: `${version}/organizations/intermediary/districts/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getIntermediaryAssociations = ({ params, version = 'v1' }) =>
  client
    .request({
      url: `${version}/organizations/intermediary-associations/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
